import React, { Component } from 'react';
import {
    Card,
    Col,
    Statistic,
    Icon,
} from "antd";
class activityCard extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {

        const { className, title, bordered, bodyStyle, headStyle, actions } = this.props.cardStyle;
        const { statisticColData } = this.props;
        return (<div> <Col xs={24} sm={24} md={8} lg={6} xl={6} span={6}>
            <Card
                className={className}
                title={title}
                bordered={bordered}
                bodyStyle={bodyStyle}
                headStyle={headStyle}
                hoverable
                actions={actions}
                style={{ marginBottom: 20 }}
            >
                {statisticColData.map((data) => (<Col span={24/statisticColData.length}>
                    <Statistic title={data[0]} value={data[1]} prefix={data[2]} />
                </Col>))}
            </Card></Col></div>);
    }
}

export default activityCard;
